module.exports = __webpack_public_path__ + "/images/cover-hucha-inicio2x.b525032.jpg";